"use client";

import { Card, CardContent, CardHeader, Grid } from "@mui/material";

import { OpenAccountUser } from "@/types/openAccount";

import { useOpenAccount } from "@/context/openAccount";
import { useRecaptcha } from "@/context/util/recaptcha";
import { useSecuritySettings } from "@/context/util/securitySettings";

import PasswordForm from "@/components/password/form";
import PinForm from "@/components/pin/form";
import QuestionForm from "@/components/question/form";

export default function SetupForm() {
  const { showV2 } = useRecaptcha();
  const { questions } = useSecuritySettings();
  const { errors, openAccountUser, setErrors, setOpenAccountUser } =
    useOpenAccount();

  if (openAccountUser?.needsSetup) {
    return (
      <Grid container spacing={2} mt={2}>
        <Grid
          key="security-question-answer-grid"
          size={{ xs: 12, md: 6 }}
          mb={2}
          sx={{ display: "flex", flexDirection: "column", padding: 0 }}
        >
          <Card sx={{ flexGrow: 1 }}>
            <CardHeader
              title="Set Security Settings"
              slotProps={{ title: { fontWeight: "bold", color: "primary" } }}
            />
            <CardContent sx={{ flexGrow: 1 }}>
              <QuestionForm<OpenAccountUser>
                entity={openAccountUser}
                errors={errors}
                questions={questions}
                set={setOpenAccountUser}
                setErrors={setErrors}
                showV2={showV2}
              />
              <PinForm<OpenAccountUser>
                entity={openAccountUser}
                errors={errors}
                set={setOpenAccountUser}
                setErrors={setErrors}
              />
            </CardContent>
          </Card>
        </Grid>
        <Grid
          size={{ xs: 12, md: 6 }}
          mb={2}
          sx={{ display: "flex", flexDirection: "column", padding: 0 }}
        >
          <Card sx={{ flexGrow: 1 }}>
            <CardHeader
              title="Set Password"
              slotProps={{ title: { fontWeight: "bold", color: "primary" } }}
            />
            <CardContent sx={{ flexGrow: 1 }}>
              <PasswordForm<OpenAccountUser>
                entity={openAccountUser}
                errors={errors}
                setErrors={setErrors}
                set={setOpenAccountUser}
              />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    );
  }

  return null;
}
